import React from 'react';
import SecTagNormalizationConfig from './SecTagNormalizationConfig';

/**
 * Full-screen modal wrapper for the SEC XBRL tag → normalized column editor.
 *
 * Props:
 *   onClose()  — called when the user dismisses the modal
 */
export default function SecTagNormalizationModal({ onClose }) {
  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1055 }} onClick={onClose} />
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ zIndex: 1060, overflowY: 'auto' }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
          style={{ maxWidth: '90vw', width: '90vw' }}
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header bg-dark text-white">
              <h5 className="modal-title">
                <i className="bi bi-tags me-2" />
                SEC Tag Normalization
              </h5>
              <span
                className="text-white-50 ms-3"
                style={{ fontSize: 12, fontWeight: 400 }}
              >
                Maps raw XBRL tags to normalized tags (this helps the knowledgebase understand "Revenue" across different companies with different tagging conventions)
              </span>
              <button
                type="button"
                className="btn-close btn-close-white ms-auto"
                onClick={onClose}
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-3">
              <SecTagNormalizationConfig />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
